/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CircleArrowsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M18.5,8.5 L10.5,8.5" />
      <path d="M13.5,15.5 L5.5,15.5" />
      <polyline points="15.5 11.5 18.5 8.5 15.5 5.5" />
      <polyline points="8.5 18.5 5.5 15.5 8.5 12.5" />
      <circle cx="12" cy="12" r="11.5" />
    </g>
  </svg>
);

export default CircleArrowsIcon;
